// eslint-disable-next-line no-restricted-imports
import { observer, useAsObservableSource } from 'mobx-react-lite';
import React from 'react';
import { DnDArea } from './DnDArea';
import { FileSelector } from './FileSelector';
import { FileUploading } from './FileUploading';
import { FileUploaded } from './FileUploaded';
import { FormInputState, FormModel } from 'src_common/common/mobx-utils/Form';
import { CsvReadFile } from 'src/AppState/PromotionQuestionsState/PromotionQuestionsState';
import { FileUploadWrapper, Separator } from 'src/components/Uploader/Uploader.style';

interface PropsType {
    state: FormInputState<boolean>;
    model: FormModel<boolean>;
    maxFileSize?: number;
    hideMaxSizeInfo?: boolean;
    allowedFileTypes: string[];
    allowedMimeTypes: string[];
    file: CsvReadFile | null;
    onSelectFile: (files: File[]) => Promise<void>;
    onReplace: (event: React.SyntheticEvent) => Promise<void>;
    onRemove: () => void;
    uploadingFileName?: string | null;
}

export const Uploader = observer((propsIn: PropsType) => {
    const props = useAsObservableSource(propsIn);
    const {
        state,
        maxFileSize,
        allowedFileTypes,
        allowedMimeTypes,
        hideMaxSizeInfo,
        onSelectFile,
        onReplace,
        onRemove,
        uploadingFileName,
        file,
    } = props;

    if (uploadingFileName !== null && uploadingFileName !== undefined) {
        return <FileUploading fileName={uploadingFileName} />;
    }

    if (file !== null && state.value === true) {
        return (
            <FileUploaded
                fileName={file.fileName}
                uploadedAt={file.uploadedAt}
                onReplace={onReplace}
                onRemove={onRemove}
            />
        );
    }

    return (
        <FileUploadWrapper>
            <DnDArea
                onDrop={onSelectFile}
                label='Drag and Drop a CSV file here'
                allowedMimeTypes={allowedMimeTypes}
            />
            <Separator>or</Separator>
            <FileSelector
                onAccept={onSelectFile}
                label='Upload CSV Files'
                maxFileSize={maxFileSize}
                hideMaxSizeInfo={hideMaxSizeInfo}
                allowedFileTypes={allowedFileTypes}
            />
        </FileUploadWrapper>
    );
});
